import DividerWithText from '../../../../../components/DividerWithText';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {AddIcon, EditIcon, TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import ScheduleTime from './ScheduleTime';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AddEditDeptSchedule from '../Modal/AddEditDeptSchedule';
import DeleteModal from '../../../../Modals/DeleteModal';
import DeptScheduleApp from '../Functionality/DeptScheduleApp';
import NotInformation from '../../../../../components/NotInformation';
import {permissionObj} from '../../../../../Helpers/permission';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const DeptSchedule = () => {

    const { t } = useTranslation();

    const {
        showCreateModal, setShowCreateModal, showDeleteModal, setShowDeleteModal, selectedIds, setSelectedIds,
        getAllFoodieDepartment, handleCreate, handleUpdate, handleDelete, deleteSchedule, DEV, permission,
        itemSelect, setItemSelect
    } = DeptScheduleApp();

    return (
        <>
            {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_CREATE)) &&
                getAllFoodieDepartment?.length > 0 && (
                    <div className='col-12 mt-3'>
                        <ButtonAction
                            id='btn_ds_create_department_schedule'
                            name='create_new_department_schedule'
                            className={'btn-outlined-secondary-600-00'}
                            disabled={false}
                            splitName={false}
                            Icon={AddIcon}
                            onClick={(e) => {
                                handleCreate(e);
                            }}
                        />
                    </div>
                )}
            {getAllFoodieDepartment?.length > 0 ? (
                <>
                    {getAllFoodieDepartment
                        ?.filter((picker) => picker.departmentId === null)
                            ?.map((picker, index) => (
                            <div key='default'>
                                <div className='d-flex justify-content-between align-items-center my-4 px-3'>
                                    <h5 className='font-color-general-950 ibl-h5 ibl-font-w-600'>
                                        {picker.departmentId === null
                                            ? t('default_departments_policy')
                                            : `${t('department_policy')} ${(index + 1).toString().padStart(2, '0')}`}
                                    </h5>
                                    <div className='d-flex align-items-center gap-3 align-self-stretch'>
                                        {(DEV ||
                                            permission?.includes(
                                                permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_UPDATE,
                                            )) && (
                                            <ButtonIcon
                                                id='btn_ds_update'
                                                Icon={EditIcon}
                                                title={'update'}
                                                iconProps='btn-icon-svg-12px icon-color-general-00'
                                                onClick={(e) => {
                                                    handleUpdate(picker);
                                                }}
                                            />
                                        )}

                                        {(DEV ||
                                            permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_DELETE)) &&
                                            picker?.departmentId != null && (
                                                <ButtonIcon
                                                    id='btn_ds_delete'
                                                    Icon={TrashOutlineIcon}
                                                    className='btn-icon-delete'
                                                    iconProps='btn-icon-svg-12px icon-color-general-00'
                                                    title={'delete'}
                                                    onClick={(e) => {
                                                        handleDelete(picker);
                                                    }}
                                                />
                                            )}
                                    </div>
                                </div>
                                <ScheduleTime item={picker} disabled={true} emptyFields={false} isValidTime={true} />
                            </div>
                        ))}
                    {getAllFoodieDepartment
                        ?.filter((picker) => picker.departmentId !== null)
                        ?.map((picker, index) => (
                            <div key={picker.departmentId}>
                                <div className='d-flex justify-content-between align-items-center my-4 px-3'>
                                    <h5 className='font-color-general-950 ibl-h5 ibl-font-w-600'>
                                        {`${t('department_policy')} ${(index + 1).toString().padStart(2, '0')}`}
                                    </h5>
                                    <div className='d-flex align-items-center gap-3 align-self-stretch'>
                                        {(DEV ||
                                            permission?.includes(
                                                permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_UPDATE,
                                            )) && (
                                            <ButtonIcon
                                                Icon={EditIcon}
                                                title={'update'}
                                                iconProps='btn-icon-svg-12px icon-color-general-00'
                                                onClick={() => handleUpdate(picker)}
                                            />
                                        )}

                                        {(DEV ||
                                            permission?.includes(
                                                permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_DELETE,
                                            )) && (
                                            <ButtonIcon
                                                Icon={TrashOutlineIcon}
                                                className='btn-icon-delete'
                                                iconProps='btn-icon-svg-12px icon-color-general-00'
                                                title={'delete'}
                                                onClick={() => handleDelete(picker)}
                                            />
                                        )}
                                    </div>
                                </div>

                                <ScheduleTime item={picker} disabled={true} emptyFields={false} isValidTime={true} />
                            </div>
                        ))}
                </>
            ) : (
                <div className='mt-4'>
                    <NotInformation>
                        <div className={'warning-text'}>
                            <p>{t('you_have_not_created_department_schedule_yet')}</p>
                        </div>
                        {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_CREATE)) && (
                            <CustomButtonLink
                                splitName={false}
                                id={'btn_ds_create_department_access'}
                                card={true}
                                onClick={(e) => {
                                    handleCreate(e);
                                }}
                                name={'create_new_department_schedule'}
                            />
                        )}
                    </NotInformation>
                </div>
            )}


        {showCreateModal &&
            <AddEditDeptSchedule
                title={itemSelect && itemSelect.id ? 'update_department_schedule' : 'create_department_schedule'}
                show={showCreateModal}
                onHide={() => {
                    setItemSelect(null)
                    setShowCreateModal(false)}
                }
                itemSelect={itemSelect}
            />
        }

        {showDeleteModal &&
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                data={selectedIds}
                onClickFn={() => deleteSchedule(selectedIds)}
                title_modal='delete_department_schedule'
                element_modal={t('department_schedule')}
                isReset={setSelectedIds}
            />
        }

    </>)

}

export default DeptSchedule;
